module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_c('div', [_c('basic-select', {
    attrs: {
      "options": _vm.options,
      "selected-option": _vm.item,
      "is-disabled": _vm.isDisabled,
      "customAttr": _vm.customAttr
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-result"
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.item.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.text))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("value")]), _vm._v(" "), _c('th', [_vm._v("text")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ccc0e154!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sample/Basic/_CustomAttr.vue
// module id = 407
// module chunks = 2